import { render, staticRenderFns } from "./shipmentSettingsModal.vue?vue&type=template&id=609d71f0"
import script from "./shipmentSettingsModal.vue?vue&type=script&lang=js"
export * from "./shipmentSettingsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports